export const AVAILABILITY_LABELS: Record<string, string> = {
  available: "Available for enquiries",
  busy: "Busy, ask about later dates",
  not_taking_work: "Not taking work",
};

export function isAvailabilityFresh(confirmedAt?: string | null, now = Date.now()): boolean {
  if (!confirmedAt) return false;
  const age = now - Date.parse(confirmedAt);
  return Number.isFinite(age) && age >= 0 && age <= 14 * 24 * 60 * 60 * 1000;
}

export function availabilityLabel(status: string, confirmedAt?: string | null): string {
  if (status === "not_taking_work") return AVAILABILITY_LABELS[status];
  return isAvailabilityFresh(confirmedAt)
    ? AVAILABILITY_LABELS[status] ?? "Ask about availability"
    : "Ask about availability";
}
